import { useDispatch, useSelector } from 'react-redux';
import {
  getDefaultSubscriptionSelector,
  getPetSelector,
} from '@modules/subscriptions/core/selectors';
import { reactivateSubscriptionRequest } from '@modules/subscriptions/core/actions';
import { Headline } from '@components/index';
import { SubscriptionReactivationInfo } from '../SubscriptionReactivationInfo';
import { getSubscriptionReactivate } from '@constants/subscription';
import { toAbsoluteUrl } from '@shared';
import { FormattedMessage, useIntl } from 'react-intl';

export const SubscriptionReactivate = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const defaultSubscription = useSelector(getDefaultSubscriptionSelector);
  const pet = useSelector(getPetSelector);

  const subscriptionReactivate = getSubscriptionReactivate(intl, pet as any);

  const handleReactivateSubscription = () => {
    dispatch(
      reactivateSubscriptionRequest({
        id: defaultSubscription?.id!,
      }),
    );
  };

  return (
    <>
      <div className="flex justify-between mx-[1.5rem] md:hidden mb-[1rem] items-center">
        <span className="subscription-reactivation-status h-fit subscription-reactivation-status-cancelled ">
          <FormattedMessage id="SUBSCRIPTION.STATUS.CANCELLED" />
        </span>
        <Headline className="!mb-0 !mx-0" hasDropdown></Headline>
      </div>

      <Headline className="!mb-[2rem] md:!mb-[2rem] mx-[1.5rem]">
        <FormattedMessage id="SUBSCRIPTION.REACTIVATE.PAGE_HEADING" />
      </Headline>

      <div className="md:flex gap-[1.2rem]">
        <SubscriptionReactivationInfo
          {...subscriptionReactivate}
          onReactivateClick={handleReactivateSubscription}
        />

        <div className="canceled-subscription">
          <h3>
            <FormattedMessage
              id="SUBSCRIPTION.CANCELLED_HEADING"
              values={{ strong: (chunks) => <strong>{chunks}</strong> }}
            />
          </h3>
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet={toAbsoluteUrl(
                '/media/svg/subscription-reactivation/canceled-subscription-desktop.webp',
              )}
            />
            <img
              src={toAbsoluteUrl(
                '/media/svg/subscription-reactivation/canceled-subscription-mobile.webp',
              )}
              alt="subscription-reactivation"
            />
          </picture>
        </div>
      </div>
    </>
  );
};
